import { apiSlice } from "./apiSlice";
import Stripe from "stripe";

interface PaymentMethodResponse {
  card?: Array<{ id: string } & Stripe.PaymentMethod.Card>;
  acss_debit?: Array<{ id: string } & Stripe.PaymentMethod.AcssDebit>;
}

const ACCOUNTS_URL = "/accounts";

export const accountsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    session: builder.mutation({
      query: ({ stripeId }) => ({
        url: `${ACCOUNTS_URL}/account_session/${stripeId}`,
        method: "GET",
      }),
    }),
    getCreateIntent: builder.query<any, void>({
      query: () => ({
        url: `${ACCOUNTS_URL}/setup`,
        method: "GET",
      }),
      keepUnusedDataFor: 300,
    }),
    getStripe: builder.query<any, void>({
      query: () => ({
        url: `${ACCOUNTS_URL}/stripe`,
      }),
      providesTags: (result) =>
        result
          ? [{ type: "Payment", id: result?.stripeId || "LIST" }]
          : [{ type: "Payment", id: "LIST" }],
    }),
    deleteBank: builder.mutation({
      query: ({ bankId }) => ({
        url: `${ACCOUNTS_URL}/payments/${bankId}`,
        method: "DELETE",
      }),
      invalidatesTags: ({ userId }) => [{ type: "Payment", id: userId }],
    }),
    getPayments: builder.query<PaymentMethodResponse, void>({
      query: () => ({
        url: `${ACCOUNTS_URL}/payments`,
      }),
      providesTags: (result) =>
        result
          ? [
              ...(result.card ?? [])
                .filter((c) => c.id !== null)
                .map((c) => ({
                  type: "Payment" as const,
                  id: c.id!,
                })),
              ...(result.acss_debit ?? [])
                .filter((b) => b.id !== null)
                .map((b) => ({
                  type: "Payment" as const,
                  id: b.id!,
                })),
              { type: "Payment" },
            ]
          : [{ type: "Payment" }],
    }),
  }),
});

export const {
  // useCreateMutation,
  useSessionMutation,
  useGetCreateIntentQuery,
  useLazyGetCreateIntentQuery,
  useGetStripeQuery,
  useDeleteBankMutation,
  useGetPaymentsQuery,
} = accountsApiSlice;
